import { connect } from "react-redux";

import * as actions from "./actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)

function mapStateToProps(state) {
  return { reports: state.reports };
}

function mapDispatchToProps(dispatch) {
  return {
    changeUCReportsListPage: (page) => {
      dispatch(actions.change_uc_reports_list_page(page));
    },

    changeUCReportsListFilter: (type, key, value) => {
      dispatch(actions.change_uc_reports_list_filter(key, value));
    },

    getSekTaxReport: (month, year) => {
      dispatch(actions.get_tax_reports(month, year));
    },

    getEurTaxReport: (month, year) => {
      dispatch(actions.get_euro_tax_reports(month, year));
    },

    transferTax: (amount, bankPaymentId, currency) => {
      dispatch(actions.transfer_tax(amount, bankPaymentId, currency));
    },

    getMonthReport: (month, year, currency) => {
      dispatch(actions.get_monthly_reports(month, year, currency));
    },

    getBorrowerDepots: () => {
      dispatch(actions.get_borrower_depots());
    },
  };
}

export const reportsConnector = connect(mapStateToProps, mapDispatchToProps);
